// extracted by mini-css-extract-plugin
module.exports = {"subItem":"LikesButton_subItem__e4JHF","button":"LikesButton_button__ttbS3","liked":"LikesButton_liked__K9u1X"};